import type { Article } from "./types";

export const passwordProtectedEventPage: Article = {
  slug: "password-protected-event-page",
  published: true,
  publishedAt: "2026-10-06",
  updatedAt: "2026-10-06",
  title: {
    ro: "Pagina evenimentului protejată cu parolă",
    en: "A password-protected event page",
  },
  summary: {
    ro: "Cum pui o parolă pe pagina evenimentului, ce văd invitații și cum schimbi sau dezactivezi parola.",
    en: "How to put a password on the event page, what guests see and how to change or turn off the password.",
  },
  body: {
    ro: [
      { t: "p", text: "Dacă nu vrei ca oricine are link-ul să vadă pagina evenimentului, o poți proteja cu o parolă." },
      { t: "h2", text: "Activează parola" },
      { t: "p", text: "În editorul evenimentului, în tab-ul „Pagina Eveniment”, activează opțiunea „Protejează cu parolă”, completează „Parola evenimentului” și salvează modificările." },
      { t: "p", text: "Din acel moment, invitații au nevoie de parolă pentru a vedea pagina. Trimite-le parola împreună cu link-ul." },
      { t: "h2", text: "Ce văd invitații" },
      { t: "p", text: "La deschiderea paginii apare mesajul „Protejat cu Parolă”, cu un câmp pentru parolă. După ce introduc parola corectă, pagina se afișează normal." },
      { t: "p", text: "După mai multe încercări greșite, introducerea parolei este blocată temporar, iar pagina le arată invitaților după cât timp pot încerca din nou." },
      { t: "h2", text: "Schimbă sau dezactivează parola" },
      { t: "p", text: "O parolă deja setată nu mai este afișată în editor. Ca să o schimbi, introdu o parolă nouă și salvează. Ca să faci pagina din nou accesibilă fără parolă, dezactivează „Protejează cu parolă” și salvează." },
    ],
    en: [
      { t: "p", text: "If you do not want everyone who has the link to see the event page, you can protect it with a password." },
      { t: "h2", text: "Turn on the password" },
      { t: "p", text: "In the event editor, on the “Event Landing Page” tab, turn on “Password protect landing page”, fill in the “Event password” and save your changes." },
      { t: "p", text: "From then on, guests need the password to see the page. Send them the password together with the link." },
      { t: "h2", text: "What guests see" },
      { t: "p", text: "When they open the page, they see the “Password Protected” message with a password field. Once they enter the correct password, the page is shown as usual." },
      { t: "p", text: "After several wrong attempts, password entry is locked for a while, and the page tells guests when they can try again." },
      { t: "h2", text: "Change or turn off the password" },
      { t: "p", text: "A password that is already set is not shown in the editor. To change it, enter a new password and save. To make the page accessible without a password again, turn off “Password protect landing page” and save." },
    ],
  },
};
